import { z } from "zod";
import { INCIDENT_STATUSES } from "@ghostwatch/shared-types";
import { severitySchema, uuidSchema } from "./common";

export const incidentStatusSchema = z.enum(INCIDENT_STATUSES);

/** `POST /v1/incidents` body. Mirrors `CreateIncident` in routes_ops.rs. */
export const createIncidentSchema = z.object({
  title: z.string().trim().min(1, "title is required").max(300),
  severity: severitySchema,
  asset_ids: z.array(uuidSchema).default([]),
  summary: z.string().trim().max(8192).optional().or(z.literal("")),
});
export type CreateIncidentInput = z.infer<typeof createIncidentSchema>;

/** `POST /v1/incidents/:id/comment` body. */
export const commentIncidentSchema = z.object({
  text: z.string().trim().min(1, "comment cannot be empty").max(8192),
});
export type CommentIncidentInput = z.infer<typeof commentIncidentSchema>;

/** `POST /v1/incidents/:id/status` body. */
export const transitionIncidentSchema = z.object({
  to: incidentStatusSchema,
});
export type TransitionIncidentInput = z.infer<typeof transitionIncidentSchema>;
